var modal = document.getElementById("myModal");

// Get the button that opens the modal
var btn = document.getElementById("myBtn");

// Get the <span> element that closes the modal
var span = document.getElementsByClassName("close")[0];

// When the user clicks on <span> (x), close the modal
$(".card_popup_close").click(function(){
  $(".card_popup").hide();
   $('#MainContent').show();
});

$(".open_learn_more").click(function(){
  var id = $(this).attr("data-learn");
   $('.holiday_'+id).css("display",'flex');
});

$(".holiday_offer_close").click(function(){
   $('.holiday_offer').hide();
});

$(".buy_now").on('click', function(){
  var id = $(this).attr("data-buy");
	console.log(id);
  
   $(".holiday_check_"+id).prop("checked", false);
   $('.holiday_offer').hide();
});

$(".ship_later").on('click', function(){
  var id = $(this).attr("data-ship");
  console.log(id);
   $(".holiday_check_"+id).prop("checked", true);
   $('.holiday_offer').hide();
});
